const authRoutes = {
    signIn: '/sign_in',
    signUp: '/sign_up',
    verify: '/verify',
    createNewPassword: '/create_new_password',
    forgotPassword: '/forgot_password',
    orderHistory: '/order_history',
};

export default authRoutes;